import { render, staticRenderFns } from "./IconTypeformYesNo.vue?vue&type=template&id=bfabf3c4&"
import script from "./IconTypeformYesNo.vue?vue&type=script&lang=ts&"
export * from "./IconTypeformYesNo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports